import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useEditCategoryMutation,
  useGetCategoriesQuery,
} from "../../../../../redux/Service/categoryApi";

function Categories() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: categoriesData, isLoading: isCategoriesLoading } =
    useGetCategoriesQuery(undefined);

  const categories = categoriesData?.ResponseObject ?? [];

  const [deleteCategory, { isLoading: isDeleting }] =
    useDeleteCategoryMutation();
  const [addCategory, { isLoading: isAdding }] = useAddCategoryMutation();
  const [updateCategory, { isLoading: isUpdating }] = useEditCategoryMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الصنف "${record.CategoryName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteCategory(record.CategoryID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف الصنف بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "كود التصنيف",
      dataIndex: "CategoryID",
      key: "CategoryID",
    },
    {
      title: "اسم التصنيف",
      dataIndex: "CategoryName",
      key: "CategoryName",
    },
  ];

  const handleOk = async (values: any) => {
    // For adding a new category, only send CategoryName.
    const body = {
      CategoryName: values.CategoryName,
      ...(isEditing && { CategoryID: values.CategoryID }),
    };

    try {
      let response;
      if (isEditing) {
        response = await updateCategory(body).unwrap();
      } else {
        response = await addCategory(body).unwrap();
      }
      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل الصنف بنجاح" : "تمت إضافة الصنف بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = { ...record };
    // If any date fields are needed, convert with dayjs here.
    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={categories}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isCategoriesLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Categories;
